import { Component, Mixins, Prop } from 'vue-property-decorator'
import { NumberMixin } from '@kwixeo/interface-vue'
import { BTooltip } from 'bootstrap-vue'
import { mapGetters } from 'vuex'

@Component({
  components: {
    BTooltip
  },
  computed: {
    ...mapGetters('subscriptions', ['hasModule'])
  }
})
export default class ProductStockIndicator extends Mixins(NumberMixin) {
  hasModule!: (key: string) => boolean

  @Prop({ required: true }) product!: KwixeoCatalog.Product
  @Prop({ default: null }) variation!: KwixeoCatalog.ProductVariation
  @Prop({ default: null }) location!: KwixeoCatalog.StockLocation|null
  @Prop({ default: null }) location2!: KwixeoCatalog.StockLocation|null
  @Prop({ default: true }) real!: boolean|undefined
  @Prop({ default: false }) theorical!: boolean|undefined

  get element (): KwixeoCatalog.Product|KwixeoCatalog.ProductVariation|null {
    if (this.product.variations_length > 0) {
      return this.variation
    }
    return this.product
  }

  get stockLocation (): KwixeoCatalog.ProductStockLocation|undefined {
    const value = this.element?.stock_locations?.find(val => val.stock_location_id === this.location?.id)
    return value ?? {
      stock_location_id: this.location?.id,
      stock_location: this.location,
      stock_theoretical_quantity: 0,
      stock_quantity: 0,
      total_stock_theoretical_ht: 0,
      total_stock_ht: 0
    } as KwixeoCatalog.ProductStockLocation
  }

  get stockLocation2 (): KwixeoCatalog.ProductStockLocation|undefined {
    const value = this.element?.stock_locations?.find(val => val.stock_location_id === this.location2?.id)
    return value ?? {
      stock_location_id: this.location2?.id,
      stock_location: this.location2,
      stock_theoretical_quantity: 0,
      stock_quantity: 0,
      total_stock_theoretical_ht: 0,
      total_stock_ht: 0
    } as KwixeoCatalog.ProductStockLocation
  }
}
